import { render, staticRenderFns } from "./solugan.vue?vue&type=template&id=00c0e32c&scoped=true"
import script from "./solugan.vue?vue&type=script&lang=js"
export * from "./solugan.vue?vue&type=script&lang=js"
import style0 from "./solugan.vue?vue&type=style&index=0&id=00c0e32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0e32c",
  null
  
)

export default component.exports